// Un déploiement remplace les assets hachés.
// Un index.html en cache vise alors des chunks absents.
// Un rechargement unique récupère l'index à jour.
const RELOAD_KEY = "qualneo:chunk-reload-at"
// Fenêtre de garde : pas de boucle si le chunk manque.
const RELOAD_WINDOW_MS = 30_000

const CHUNK_ERROR = /Failed to fetch dynamically imported module|Importing a module script failed|error loading dynamically imported module|Unable to preload CSS/i

export function isChunkLoadError(error: unknown): error is Error {
  return error instanceof Error && CHUNK_ERROR.test(error.message)
}

/**
 * Recharge la page une fois par fenêtre.
 * Rend `true` si le rechargement est lancé.
 * @example reloadOnceForStaleChunk(new TypeError("Failed to fetch dynamically imported module: /a.js")) // true
 */
export function reloadOnceForStaleChunk(error: unknown, now: number = Date.now()): boolean {
  if (!isChunkLoadError(error)) return false
  try {
    const last = Number(window.sessionStorage.getItem(RELOAD_KEY) ?? "0")
    if (now - last < RELOAD_WINDOW_MS) return false
    window.sessionStorage.setItem(RELOAD_KEY, String(now))
  } catch {
    return false
  }
  window.location.reload()
  return true
}
